import mifosRepository, {MifosRepository} from "./MifosRepository";
import {ContentTypes} from "@/utils/ContentTypes";

const resource = "/staff";
export default {

  getStaffDetails(staffId) {
    mifosRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return MifosRepository.get(`${resource}/${staffId}`);
  }
};
